import { useTranslation } from 'react-i18next'
import { Br, Ca } from 'react-flags-select'
import { isCanonicalSiteHost, getLocaleUrl } from 'resources/siteLocales'

import {
	NavbarWrapper,
	Monogram,
	TitleImage,
	FlagWrapper,
	FlagsContainer,
} from './styles'

const links = [
	{ id: 'hero', label: 'Home' },
	{ id: 'our-story', label: 'Nossa História' },
	{ id: 'info', label: 'Informações' },
	// { id: 'photos', label: 'Fotos' },
	{ id: 'gifts', label: 'Presentes' },
	{ id: 'venue', label: 'Cerimônia e Recepção' },
]

function Navbar() {
	const { i18n, t } = useTranslation()

	const handleClick = (scrollToId) => (event) => {
		event.preventDefault()
		document.getElementById(scrollToId).scrollIntoView({ behavior: 'smooth' })
	}

	const useDomainLinks = isCanonicalSiteHost(window.location.hostname)
	const toggleLanguage = (lang) => (event) => {
		if (!useDomainLinks) {
			event.preventDefault()
			i18n.changeLanguage(lang)
		}
	}
	const languageLink = (lang) =>
		useDomainLinks ? getLocaleUrl(lang, window.location.hash) : '#'

	return (
		<NavbarWrapper id="main-nav" className="navbar navbar-expand-lg sticky-top">
			<div className="container">
				<div className="navbar-brand d-flex flex-row align-items-center">
					<Monogram />
					<TitleImage />
				</div>
				<button
					className="navbar-toggler"
					type="button"
					data-bs-toggle="collapse"
					data-bs-target="#navbarNav"
					aria-controls="navbarNav"
					aria-expanded="false"
					aria-label="Toggle navigation"
				>
					<i className="fa-sharp fa-solid fa-bars" />
				</button>
				<div
					className="collapse navbar-collapse justify-content-end"
					id="navbarNav"
				>
					<ul className="navbar-nav">
						{links.map(({ id, label }) => (
							<li key={id} className="nav-item">
								<a
									href={`#${id}`}
									className="nav-link"
									aria-current="page"
									onClick={handleClick(id)}
								>
									{t(label)}
								</a>
							</li>
						))}
					</ul>
					<FlagsContainer>
						<FlagWrapper
							href={languageLink('pt-BR')}
							hrefLang="pt-BR"
							aria-label="Português (Brasil)"
							aria-current={i18n.language === 'pt-BR' ? 'page' : undefined}
							onClick={toggleLanguage('pt-BR')}
							active={i18n.language === 'pt-BR'}
						>
							<Br aria-hidden="true" />
						</FlagWrapper>
						<FlagWrapper
							href={languageLink('en')}
							hrefLang="en"
							aria-label="English"
							aria-current={i18n.language === 'en' ? 'page' : undefined}
							onClick={toggleLanguage('en')}
							active={i18n.language === 'en'}
						>
							<Ca aria-hidden="true" />
						</FlagWrapper>
					</FlagsContainer>
				</div>
			</div>
		</NavbarWrapper>
	)
}

export default Navbar
